import React, { useState } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { FaArrowRight, FaGlobe, FaCheckCircle, FaStar } from 'react-icons/fa';
import { destinations } from '../data/destinationsData';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HeroSlider.css';

const HeroSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        pauseOnHover: false,
        arrows: false, // Cleaner look without arrows
        beforeChange: (current, next) => setCurrentSlide(next),
        cssEase: "ease-in-out" // Smoother transition
    };

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // simplified motion variants - no bouncing
    const fadeUp = {
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 1, delay: 0.2 } }
    };

    return (
        <div className="hero-slider">
            <Slider {...settings}>
                {destinations.map((destination, index) => (
                    <div key={destination.id}>
                        <div className="hero-slide">
                            {/* Background Image */}
                            <div
                                className="hero-background"
                                style={{ backgroundImage: `url(${destination.image})` }}
                            >
                                <div className="hero-overlay"></div>
                            </div>

                            {/* Content */}
                            <div className="hero-content container">
                                <div className="hero-text">
                                    {/* Badge */}
                                    <motion.div
                                        initial="hidden"
                                        animate="visible"
                                        variants={fadeIn}
                                        className="hero-badge"
                                    >
                                        <FaCheckCircle className="badge-icon" />
                                        <span>Official Visa Consultants</span>
                                    </motion.div>

                                    {/* Title */}
                                    <motion.h1
                                        initial="hidden"
                                        animate="visible"
                                        variants={fadeUp}
                                        className="hero-title"
                                        key={`title-${destination.id}`} // Force re-render for animation
                                    >
                                        {destination.title} <br />
                                        <span className="gradient-text-accent">{destination.country}</span>
                                    </motion.h1>

                                    {/* CTA Buttons */}
                                    <motion.div
                                        initial="hidden"
                                        animate="visible"
                                        variants={fadeUp}
                                        className="hero-actions"
                                    >
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => scrollToSection('contact')}
                                        >
                                            Get Free Consultation
                                            <FaArrowRight className="btn-icon-right" />
                                        </button>
                                        <button
                                            className="btn btn-glass"
                                            onClick={() => scrollToSection('destinations')}
                                        >
                                            View Destinations
                                        </button>
                                    </motion.div>

                                    {/* Stats - Clean Text Only */}
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        className="hero-stats"
                                    >
                                        <div className="stat-item">
                                            <h3 className="stat-number">98%</h3>
                                            <p className="stat-label">Visa Success</p>
                                        </div>

                                        <div className="stat-divider"></div>

                                        <div className="stat-item">
                                            <h3 className="stat-number">500+</h3>
                                            <p className="stat-label">Students Placed</p>
                                        </div>

                                        <div className="stat-divider"></div>

                                        <div className="stat-item">
                                            <h3 className="stat-number">5+</h3>
                                            <p className="stat-label">Years Experience</p>
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default HeroSlider;
